module.exports = __webpack_public_path__ + "static/icons/icon-river--green-4cde8073c5f5ad04d68269dfa374353f.svg";